module.exports = __webpack_public_path__ + "static/media/ipo_occupation.6b4443c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/ipo_occupation.png
// module id = 506
// module chunks = 0